/**
 * @file optinConstants.js
 * @description Constants for the Optin module within the Dashboard section.
 *              Includes UI label strings, tab configurations, and a date formatting utility.
 *
 * @module optinConstants
 *
 * @exports OPTIN_STRINGS   - UI label strings for the optin search panel.
 * @exports OPTIN_TABS      - Tab label strings for the optin panel.
 * @exports formatDateTime    - Utility function to format date/time values.
 */
export const OPTIN_STRINGS = {
    NO_RESULTS: "No Record Found",
};

export const OPTIN_TABS = {
    TEXTS: "Texts",
	EMAILS: "Emails",
};

export const formatDateTime = (value) => {
    if (!value) return null;
    if (value instanceof Date && !isNaN(value)) {
        const pad = (n, z = 2) => String(n).padStart(z, "0");
        return (
            value.getFullYear() + "-" +
            pad(value.getMonth() + 1) + "-" +
            pad(value.getDate()) + " " +
            pad(value.getHours()) + ":" +
            pad(value.getMinutes()) + ":" +
            pad(value.getSeconds()) + "." +
            pad(value.getMilliseconds(), 3)
        );
    }
    if (typeof value === "string") {
        return value.replace("T", " ").replace("Z", "");
    }
    return null;
};
